import { dateTimeTypePolicy } from "./scalar-types";

export const scalarTypePolicies = {
  Beneficiary: {
    fields: { createdAt: dateTimeTypePolicy, terminatedAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BeneficiaryDelivery: {
    fields: { approvedAt: dateTimeTypePolicy, receivedAt: dateTimeTypePolicy, stagedAt: dateTimeTypePolicy },
  },
  BeneficiaryTransactionSet: { fields: { receivedAt: dateTimeTypePolicy } },
  CaseRecommendation: { fields: { generatedAt: dateTimeTypePolicy } },
  CaseRoom: { fields: { openedAt: dateTimeTypePolicy, snapshotAt: dateTimeTypePolicy } },
  CaseRoomTurn: { fields: { finishedAt: dateTimeTypePolicy, startedAt: dateTimeTypePolicy } },
  CrawlDocumentCount: { fields: { firstSavedAt: dateTimeTypePolicy, lastSavedAt: dateTimeTypePolicy } },
  CrawlProgress: { fields: { endedAt: dateTimeTypePolicy, startedAt: dateTimeTypePolicy } },
  EligibilityInspection: { fields: { ranAt: dateTimeTypePolicy } },
  EligibilityInspectionSnapshot: { fields: { storedAt: dateTimeTypePolicy } },
  EligibilityOpsUser: { fields: { enrolledAt: dateTimeTypePolicy, lastCheckedAt: dateTimeTypePolicy } },
  EmailSendView: {
    fields: { requestedAt: dateTimeTypePolicy, scheduledFor: dateTimeTypePolicy, sentAt: dateTimeTypePolicy },
  },
  ExecutionResultArtifact: { fields: { createdAt: dateTimeTypePolicy } },
  HealthRecordCaseAction: { fields: { sentAt: dateTimeTypePolicy } },
  HealthRecordLinkedCase: {
    fields: {
      billPaidAt: dateTimeTypePolicy,
      closedAt: dateTimeTypePolicy,
      escalatedAt: dateTimeTypePolicy,
      openedAt: dateTimeTypePolicy,
    },
  },
  InsuranceCheckStatus: {
    fields: {
      lastAnsweredAt: dateTimeTypePolicy,
      lastAttemptAt: dateTimeTypePolicy,
      lastRequestedAt: dateTimeTypePolicy,
    },
  },
  InsuranceMembership: { fields: { confirmedAt: dateTimeTypePolicy } },
  InsurancePosition: { fields: { lastChangedAt: dateTimeTypePolicy } },
  InsurancePositionReading: { fields: { observedAt: dateTimeTypePolicy } },
  NateraHubCase: { fields: { openedAt: dateTimeTypePolicy } },
  NextStep: { fields: { snoozedUntil: dateTimeTypePolicy } },
  NextStepBasis: { fields: { at: dateTimeTypePolicy } },
  NextSteps: { fields: { lookingSince: dateTimeTypePolicy, sendsHeldBefore: dateTimeTypePolicy } },
  NextStepsLastLooked: { fields: { at: dateTimeTypePolicy, nextRunAt: dateTimeTypePolicy } },
  OpenCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  OrchestratorProposalFate: { fields: { at: dateTimeTypePolicy, until: dateTimeTypePolicy } },
  OrchestratorRunEntry: {
    fields: { at: dateTimeTypePolicy, deliveredAt: dateTimeTypePolicy, nextRunAt: dateTimeTypePolicy },
  },
  OrchestratorWakeEntry: { fields: { at: dateTimeTypePolicy } },
  Partner: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PartnerGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  RecordedSendView: {
    fields: { recordedAt: dateTimeTypePolicy, requestedAt: dateTimeTypePolicy, sentAt: dateTimeTypePolicy },
  },
  Referral: { fields: { createdAt: dateTimeTypePolicy, reviewedAt: dateTimeTypePolicy } },
  ReferralParty: { fields: { createdAt: dateTimeTypePolicy } },
  ReferralReviewCase: { fields: { billUploadedAt: dateTimeTypePolicy } },
  ReferralReviewRow: { fields: { signedUpAt: dateTimeTypePolicy } },
  ResourceSnapshotResult: { fields: { computedAt: dateTimeTypePolicy } },
  RpaForecastEntry: { fields: { dispatchAt: dateTimeTypePolicy } },
  RpaLinkView: { fields: { createdAt: dateTimeTypePolicy, lastSessionAt: dateTimeTypePolicy } },
  RpaSessionDot: { fields: { startedAt: dateTimeTypePolicy } },
  SatisfiedCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  StaffInboxLink: { fields: { linkedAt: dateTimeTypePolicy } },
  StaffTailgateAsk: { fields: { expiresAt: dateTimeTypePolicy } },
  StaffTailgateAttempt: { fields: { crawlStartedAt: dateTimeTypePolicy } },
  StaffTailgateFile: { fields: { takenAt: dateTimeTypePolicy } },
  StaffTailgateStep: { fields: { at: dateTimeTypePolicy } },
  StaffTailgateView: { fields: { holdUntil: dateTimeTypePolicy } },
  UnattestedCaseRequirement: { fields: { since: dateTimeTypePolicy } },
  UserHealthRecord: { fields: { receivedAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  UserUploadedDocumentsResult: { fields: { createdAt: dateTimeTypePolicy } },
  WebAgentExecutionResult: { fields: { createdAt: dateTimeTypePolicy } },
};
